
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { IPropretyAttribute, IEntityMetaData } from "../../_models/IEntityMetaData";
import { PropretyAttributes, Validation, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { FSTREAM_Image } from "./FSTREAM_Image.model";
import { PoliciesTranslation } from "./navigation-entities/PoliciesTranslation.model";
import { PointOfService } from "./PointOfService.model";


export class Policy extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  description?: string;

  numero?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  policyType!: number;

  fK_File?: number;

  isLastVersion?: boolean;

  @NestedProperty({ TargetType: FSTREAM_Image })
  file?: FSTREAM_Image;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NavigationProperty({ TargetType: PoliciesTranslation })
  policiesTranslations?: PoliciesTranslation[];

  GetType(): IEntityMetaData {
    return Policy.getMetaData();
  }
}
